import { ProjectFileUploadOptions } from 'src/store/state/projects';

export const didOnlyTheHeaderOptionChange = (
  prevOptions: ProjectFileUploadOptions,
  nextOptions: ProjectFileUploadOptions
): boolean => {
  if (prevOptions.header === nextOptions.header) {
    return false;
  }

  // we ignore skipEmpty changes
  const didEscapeChange = prevOptions.escape !== nextOptions.escape;
  const didQuoteChange = prevOptions.quote !== nextOptions.quote;
  const didSeparatorChange = prevOptions.separator !== nextOptions.separator;

  return !didEscapeChange && !didQuoteChange && !didSeparatorChange;
};
